import {CLOSE} from "@kta20-ui-base/resources/icons";

export default (message:string, color:string)=> `

    <div style="position: absolute; bottom:0; right:0; left:0; width:100%;z-index:100000; text-align: center;">
        <div style="position:relative; margin:auto; 
            width:auto; overflow:hidden; 
            max-width: 450px; padding:16px; text-align: left;
            color:white;
            background-color: ${color};
            font-family:var(--ion-font-family)">
        
            <div style="width: 70px; float: right; height: 100%; text-align: right; width: 24px">
                ${CLOSE}
            </div>
            <div style="width: auto; padding-right: 70px">${message}</div>
        </div>
    </div>

`;